import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { expVal } from '@confluence/feature-experiments';
import { NotFound } from '@confluence/not-found/entry-points/NotFound.ts';
import { SpaceContributors } from '@confluence/space-contributors/entry-points/SpaceContributors.ts';

import SpaceBase from '../../SpaceBase/index.js';

export const SpaceContributorsRoute: {
	({ params: { spaceKey } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ name, params: { spaceKey } }: RouteMatch):
		| false
		| {
				Screen: {
					screenEvent: {
						name: string;
						id: string;
					};
					pageState: {
						routeName: string;
						spaceKey: string;
					};
				};
				MainLayout: {
					navView: string;
					spaceKey: string;
					disableMinWidth: boolean;
				};
		  };
} = ({ params: { spaceKey } }: RouteMatch): React.JSX.Element => {
	if (!expVal('confluence_space_contributors', 'isEnabled', false)) {
		return <NotFound />;
	}

	return (
		<SpaceBase>
			<SpaceContributors spaceKey={spaceKey} />
		</SpaceBase>
	);
};

SpaceContributorsRoute.NAVIGATION_PARAMS = ({
	name,
	params: { spaceKey },
}: RouteMatch):
	| false
	| {
			Screen: {
				screenEvent: {
					name: string;
					id: string;
				};
				pageState: {
					routeName: string;
					spaceKey: string;
				};
			};
			MainLayout: {
				navView: string;
				spaceKey: string;
				disableMinWidth: boolean;
			};
	  } => {
	if (!expVal('confluence_space_contributors', 'isEnabled', false)) {
		return false;
	}

	return {
		Screen: {
			screenEvent: {
				name: 'spaceContributorsScreen',
				id: spaceKey,
			},
			pageState: {
				routeName: name,
				spaceKey,
			},
		},
		MainLayout: {
			navView: CONTAINER_HOME_ID,
			spaceKey,
			disableMinWidth: true,
		},
	};
};
